import React, { Component, useReducer } from 'react';
import {Collapse, OverviewToggler,OverviewBrand,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'; //import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import {Triangle} from 'react-loader-spinner'

  class Metrics extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
          metrics: [],
          loading: true
      };

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.LinkGoogleFit = () => {
        var redirect_uri = window.location.href
        var google_fit_client_id = '886472897374-s2u7n72g933iicbg45q2ofp22ptvc4fv.apps.googleusercontent.com'
        var google_fit_client_secret = 'qzq_z79ToXRnck0J4HzgOjSQ'
        var auth_prompt_uri = 'https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=https%3A%2F%2F'+redirect_uri+'&prompt=consent&response_type=code&client_id='+google_fit_client_id+'&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.activity.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.blood_glucose.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.blood_pressure.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.body.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.body_temperature.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.heart_rate.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.location.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.nutrition.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.oxygen_saturation.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.reproductive_health.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.sleep.read&access_type=offline'
        
        window.location.href = auth_prompt_uri
      }
    }

    componentDidMount() {
      window.scrollTo(0, 0)
      
      const { cookies } = this.props;
      var data = new FormData()
      data.append('user_access_token', cookies.get('token'))

      axios.post(Backend_Url + 'getGoogleFitMetrics', data)
      .then((res) => {
          let result = res.data
            this.setState({metrics: result, loading: false})
      }).catch((error) => {
          console.log(error)
      })
    }




    render() {
      if (this.state.loading == true){
        return (
          <Row>
            <Helmet>
              <title>Metrics - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <Container style={{textAlign: 'center', alignItems: 'center', justifyContent: 'center'}}>
                <br/>
                <h1 style={{color: '#47525E', fontFamily: 'Knewave', marginTop: '50px', fontWeight: 'bold'}}>
                  ONFIT
                </h1>
                <br/><br/>
                <Triangle
                    color="#1FACED"
                    height={130}
                    width={130}
                />
                <h3 style={{marginTop: '50px', color: '#1FACED'}}>
                  Loading...
                </h3>
                <h6 style={{marginTop: '50px'}}>
                    Taking too long to load? Check your internet connection and reload the page.
                </h6>
                <br/><br/>
              </Container>
            </div>
          </Row>
        )
      }

      var respiration_rate = []
      return (
        <Row>
            <Helmet>
              <title>Metrics - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <br/>
              <h4 style={{}}>
                Metrics
              </h4>
              <br/>
              <Container>
                  <div style={{textAlign: 'right'}}>
                    <Button onClick={this.LinkGoogleFit} style={{border: 'none', backgroundColor: '#1faced', color: '#ffffff', width: '180px', borderRadius: '20px'}}>
                      Link Google Fit
                    </Button>
                  </div>
                  <br/><br/><br/>
                  <Row>
                    <Col sm='4' style={{height: '350px'}}>
                      <h6 style={{fontWeight: 'bold'}}>Respiration Rate</h6>
                      <ResponsiveContainer width="100%" height="100%">
                        <LineChart
                          width={500}
                          height={300}
                          data={respiration_rate}
                          margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="time" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Line type="monotone" dataKey="rate" stroke="#1faced" activeDot={{ r: 8 }} />
                        </LineChart>
                      </ResponsiveContainer>
                    </Col>
                    <Col sm='4' style={{height: '350px'}}>
                      <h6 style={{fontWeight: 'bold'}}>Oxygen Saturation</h6>
                      <ResponsiveContainer width="100%" height="100%">
                        <LineChart
                          width={500}
                          height={300}
                          data={respiration_rate}
                          margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="time" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Line type="monotone" dataKey="saturation" stroke="#1faced" activeDot={{ r: 8 }} />
                        </LineChart>
                      </ResponsiveContainer>
                    </Col>
                    <Col sm='4' style={{height: '350px'}}>
                      <h6 style={{fontWeight: 'bold'}}>Systolic Blood Pressure</h6>
                      <ResponsiveContainer width="100%" height="100%">
                        <LineChart
                          width={500}
                          height={300}
                          data={respiration_rate}
                          margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="time" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Line type="monotone" dataKey="rate" stroke="#1faced" activeDot={{ r: 8 }} />
                        </LineChart>
                      </ResponsiveContainer>
                    </Col>
                  </Row>
                  <br/><br/><br/>
                  <Row>
                    <Col sm='4' style={{height: '350px'}}>
                      <h6 style={{fontWeight: 'bold'}}>Pulse Rate</h6>
                      <ResponsiveContainer width="100%" height="100%">
                        <LineChart
                          width={500}
                          height={300}
                          data={respiration_rate}
                          margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="time" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Line type="monotone" dataKey="rate" stroke="#1faced" activeDot={{ r: 8 }} />
                        </LineChart>
                      </ResponsiveContainer>
                    </Col>
                    <Col sm='4' style={{height: '350px'}}>
                      <h6 style={{fontWeight: 'bold'}}>Temperature</h6>
                      <ResponsiveContainer width="100%" height="100%">
                        <LineChart
                          width={500}
                          height={300}
                          data={respiration_rate}
                          margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="time" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Line type="monotone" dataKey="degrees" stroke="#1faced" activeDot={{ r: 8 }} />
                        </LineChart>
                      </ResponsiveContainer>
                    </Col>
                    <Col sm='4' style={{height: '350px'}}>
                      <h6 style={{fontWeight: 'bold'}}>Steps</h6>
                      <ResponsiveContainer width="100%" height="100%">
                        <LineChart
                          width={500}
                          height={300}
                          data={respiration_rate}
                          margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="time" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Line type="monotone" dataKey="steps" stroke="#1faced" activeDot={{ r: 8 }} />
                        </LineChart>
                      </ResponsiveContainer>
                    </Col>
                  </Row>
                  <br/><br/><br/>
                  <Row>
                    <Col sm='4' style={{height: '350px'}}>
                      <h6 style={{fontWeight: 'bold'}}>Sleep</h6>
                      <ResponsiveContainer width="100%" height="100%">
                        <LineChart
                          width={500}
                          height={300}
                          data={respiration_rate}
                          margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="time" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Line type="monotone" dataKey="hours" stroke="#1faced" activeDot={{ r: 8 }} />
                        </LineChart>
                      </ResponsiveContainer>
                    </Col>
                    <Col sm='4' style={{height: '350px'}}>
                      <h6 style={{fontWeight: 'bold'}}>Weight</h6>
                      <ResponsiveContainer width="100%" height="100%">
                        <LineChart
                          width={500}
                          height={300}
                          data={respiration_rate}
                          margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="time" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Line type="monotone" dataKey="kgs" stroke="#1faced" activeDot={{ r: 8 }} />
                        </LineChart>
                      </ResponsiveContainer>
                    </Col>
                    <Col sm='4' style={{height: '350px'}}>
                      <h6 style={{fontWeight: 'bold'}}>Blood Sugar</h6>
                      <ResponsiveContainer width="100%" height="100%">
                        <LineChart
                          width={500}
                          height={300}
                          data={respiration_rate}
                          margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="time" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Line type="monotone" dataKey="milligrams" stroke="#1faced" activeDot={{ r: 8 }} />
                        </LineChart>
                      </ResponsiveContainer>
                    </Col>
                  </Row>
                  <br/><br/><br/><br/><br/>
              </Container>
            </div>
        </Row>
      );
    }

  };
  
  export default withCookies(Metrics);